<template>
  <van-popup :value="visible" :close-on-click-overlay="false" round
    style="width: 90%; max-width: 420px; overflow: hidden;">
    <div class="contact-ad-gate">
      <div class="gate-title">{{ $t('contactAd_gateTitle') }}</div>
      <div class="gate-subtitle">{{ $t('contactAd_gateSubtitle') }}</div>
      <div class="gate-ad">
        <AdBanner type="banner" page="matches" />
      </div>
      <van-button type="primary" block round color="#E8543A" :disabled="countdown > 0" @click="onContinue">
        {{ countdown > 0 ? $t('contactAd_waitBtn', { sec: countdown }) : $t('contactAd_continueBtn') }}
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button } from 'vant'
import AdBanner from './AdBanner.vue'

export default {
  name: 'ContactAdGate',
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    AdBanner
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 需要倒计时的秒数：前 3 次短等（近似插屏），之后长等（网页版激励近似——看完才能继续）
    seconds: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      countdown: 0,
      timer: null
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.countdown = this.seconds
        this.startTimer()
      } else {
        this.stopTimer()
      }
    }
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.stopTimer()
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
          return
        }
        this.stopTimer()
      }, 1000)
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    onContinue() {
      this.$emit('continue')
    }
  }
}
</script>

<style scoped>
.contact-ad-gate {
  padding: 20px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.gate-title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A1A;
}

.gate-subtitle {
  margin-top: 6px;
  font-size: 12px;
  color: #4A4A4A;
  text-align: center;
  line-height: 1.5;
}

.gate-ad {
  width: 100%;
  margin: 12px 0;
}

.contact-ad-gate .van-button {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactAdGate.vue